import React, { Fragment, useEffect, useState } from 'react';
import PieChartClass from './PieChart';
import { Card, CardBody, CardHeader, Col } from "reactstrap";
import { H5 } from '../../../../AbstractElements';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import axios from 'axios';
import config from '../../../../config';

const Top5Categories = ({ year, month, propertyMallCode, className }) => {
    const [topFiveData, setTopFiveData] = useState({
        sales: [],
        growth: []
    });
    const [chartData, setChartData] = useState({});
    const [title, setTitle] = useState('By Sales');

    const concessionaire_id = localStorage.getItem("concessionaireId");
    const property_id = localStorage.getItem("propertyAccess");
    const token = localStorage.getItem("sessiontoken");

    const configheader = {
        headers: {
            Authorization: `${token}`
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            const apiUrl = year || propertyMallCode || month ? 'dashboardfiltered' : 'dashboard';
            const apiData = {
                concessionaire_id,
                property_id,
                year,
                propertyMallCode,
                month
            };

            try {
                if (apiUrl !== '') {
                    const [salesResponse, growthResponse] = await Promise.all([
                        axios.post(`${config.hostname}/${apiUrl}/topfivecategory`, apiData, configheader),
                        axios.post(`${config.hostname}/${apiUrl}/topfivecategorybygrowth`, apiData, configheader)
                    ]);

                    setTopFiveData({
                        sales: salesResponse.data.topFiveSubcategories,
                        growth: growthResponse.data.topFiveSubcategories
                    });

                    // Initialize chart data based on fetched data
                    updateChartData('BySales', salesResponse.data.topFiveSubcategories);
                }
            } catch (error) {
                console.error(error);
            }
        };

        fetchData();
    }, [year, month, propertyMallCode, concessionaire_id, property_id, token]); // Ensures fetch only on change

    const updateChartData = (type, data) => {
        const chartData = [["Category", "", { role: "style" }, { role: "annotation", type: "string", calc: "stringify" }]];
        data.forEach(category => {
            const value = type === 'BySales' ? category.totalSales / 1000000 : category.growthPercentage;
            const annotation = type === 'BySales' ? (category.totalSales / 1000000).toFixed(2) : category.growthPercentage.toFixed(2);
            chartData.push([
                category.subcategoryName,
                value,
                //'#4ac0ee',
                '#00b1c2',
                annotation
            ]);
        });

        setChartData({
            GoogleBarChart2: {
                width: "100%",
                height: "400px",
                chartType: "BarChart",
                data: chartData,
                option: {
                    title: type === 'BySales' ? "Top 5 Categories By Sales" : "Top 5 Categories By Growth",
                    height: 400,
                    bar: { groupWidth: "95%" },
                    backgroundColor: "transparent",
                    legend: { position: "none" }
                }
            }
        });
        setTitle(type === 'BySales' ? 'By Sales' : 'By Growth');
    };

    const handleOptionSelect = (option) => {
        updateChartData(option === 'BySales' ? 'BySales' : 'ByGrowth', option === 'BySales' ? topFiveData.sales : topFiveData.growth);
    };

    return (
        <Fragment>
            <Col sm='12' xl='6' className={className}>
                <Card>
                    <CardHeader>
                        <div>
                            <H5> <div style={{ display: 'flex', alignItems: 'center' }}>
                                <div>{'Top 5 Categories '}</div>
                                <div style={{ fontSize: '0.7em', color: '#777', marginLeft: '10px' }}>{title}</div>
                                {title === 'By Sales' ? (
                                    <div style={{ fontSize: '0.5em', color: '#777', marginLeft: '10px' }}>{'(values in millions)'}</div>
                                ) :
                                    <div style={{ fontSize: '0.5em', color: '#777', marginLeft: '10px' }}>{'(values in percentage)'}</div>
                                }
                            </div></H5>
                            <DropdownButton id="dropdown-basic-button" title="Options" variant="dark">
                                <Dropdown.Item onClick={() => handleOptionSelect('BySales')}>By Sales</Dropdown.Item>
                                <Dropdown.Item onClick={() => handleOptionSelect('ByGrowth')}>By Growth</Dropdown.Item>
                            </DropdownButton>
                        </div>
                    </CardHeader>
                    <CardBody>
                        {chartData.GoogleBarChart2 && chartData.GoogleBarChart2.data.length > 1 ? (
                            <PieChartClass data={chartData.GoogleBarChart2} />
                        ) : (
                            <div>No data...</div>
                        )}
                    </CardBody>
                </Card>
            </Col>
        </Fragment>
    );
}

export default Top5Categories;